export enum PersonalizedImageTemplateKeys {
  PDP_TEMPLATE = 'pdpTemplate',
  LAPTOP_MOBILE_TEMPLATE = 'laptopMobileTemplate',
  BRANDKIT_WIX_TEMPLATE = 'brandkitWixTemplate',
  BRANDKIT_YELP_TEMPLATE = 'brandkitYelpTemplate',
  BRANDKIT_YELP_NO_TEXT_IMAGE_TEMPLATE = 'brandkitYelpNoTextImageTemplate',
}
